import { call, query } from "./calls";
import { getAccountId } from "../account/accountUtils";

export const Query = {
    get: (id) => call(`/Query/${id}`),
    create: (query) => call(`/Query`, "POST", query),
    update: (query) => call(`/Query/${query.id}`, "PUT", query),
    search: (text) => query(`select * from Query where name like '${text}' or description like '${text}' or query like '${text}' order by name limit 10`),
    starred: () => query(`select * from Query where isNotNull(starred) and contains(starred, ${getAccountId()}) order by name`)
};